import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import PrimaryButton from '../buttons/PrimaryButton';
import { AuthContext } from '../context/Auth';
import WindowWrapper from '../context/WindowWrapper';
import CheckField from '../forms/CheckField';
import InputField from '../forms/InputField';
import HandsClapIcon from '../../assets/img/hands_clap.png';
import CheckIcon from '../../assets/img/check.png';
import SelectField from '../forms/SelectField';
import DomainData from '../../assets/datasets/DomainData';
import PlacesAutoComplete from '../forms/PlacesAutoComplete';
import { AppInfoContext } from '../context/AppInfo';
import errorHandlers from '../../api/errorHandlers';
import { WindowManagerContext } from '../context/WindowManager';
import configuration from '../../configuration';

const Signup = ({ style, close, className, ...props }) => {
  const [signedUp, setSignedUp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { mapInstance } = React.useContext(AppInfoContext);
  const { openWindow } = React.useContext(WindowManagerContext);
  const { auth, signup } = useContext(AuthContext);

  const [data, setData] = React.useState({});

  const editData = (key, value) => {
    setData(old => ({ ...old, [key]: value }));
  };

  console.log(props.madeRating, props.rating);

  const makeSignup = async (data) => {
    if (data.dataPrivacy) {
      try {
        setLoading(true);
        await signup(data);
        setSignedUp(true);
        setLoading(false);
        // alert('Registriert');
      } catch (e) {
        errorHandlers.signupErrorHandler(e.response.data);
        setLoading(false);
      }
    } else {
      alert('Bitte bestätige noch die Datenschutzbestimmungn und die AGB');
    }
  };

  React.useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <>
      <WindowWrapper
        maxWidth={600}
        maxHeight={600}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={style}
        close={close}
      >
        {
          signedUp
            ? (
              <center>
                <img src={CheckIcon} width={100} />
                <h3 style={{ fontWeight: 'bold', fontSize: 24 }}>Herzlich Willkommen bei Felix Medicus!</h3>
                <p style={{ color: 'grey', marginBottom: 0 }}>
                  Jetzt hast du Zugriff auf alle (zukünftigen) Bewertungen auf unserer Plattform.<br />
                  <br />
                </p>
                <PrimaryButton onClick={() => { close(); openWindow('login', {}); }}>Jetzt einloggen</PrimaryButton>
              </center>
              )
            : (
              <>
                {
              auth.loggedIn
                ? (
                  <>Schon eingeloggt</>
                  )
                : (
                  <>
                    <center><img src={HandsClapIcon} width={80} /></center>
                    <br />
                    <center><h3 style={{ fontWeight: 'bold', fontSize: 24 }}>Dein Schritt für eine bessere Zukunft als Ärzt:in</h3></center>
                    <p style={{ color: 'grey', marginBottom: 0 }}>
                      Unsere Bewertungsplattform entwickelt sich tagtäglich weiter. Damit du langfristig davon profitieren kannst, brauchen wir die folgenden Angaben:
                    </p>
                    <br />
                    {/* <p style={{ color: 'grey', marginBottom: 0 }}>Vertrieblicher Support</p>
            <p style={{ fontSize: 24 }}>0176 / 473 39736</p> */}

                    <table>
                      <tr>
                        <td>
                          <CheckField
                            setValue={(value) => editData('job_search', value)}
                            value={data.job_search}
                            classic
                          />
                        </td>
                        <td>
                          <p style={{ paddingLeft: 10, fontSize: 14, marginBottom: 0, color: 'grey' }}>
                            Ich suche gerade nach einem Job
                          </p>
                        </td>
                      </tr>
                    </table>
                    <br />
                    <b>Dein Vorname</b>
                    <InputField value={data.firstName || ''} setValue={value => editData('firstName', value)} label='Vorname' placeholder='Vorname' />
                    <b>Dein Nachname</b>
                    <InputField value={data.lastName || ''} setValue={value => editData('lastName', value)} label='Nachname' placeholder='Nachname' />

                    <b>Deine E-Mail-Adresse</b>
                    <InputField value={data.email || ''} setValue={value => editData('email', value)} type='email' label='E-Mail-Adresse' placeholder='E-Mail-Adresse' />
                    <b>Deine Handynummer</b><br />
                    <InputField value={data.phone || ''} name='phone' setValue={value => editData('phone', value)} type='phone' label='Handy-Nr.' placeholder='Handy-Nr.' />
                    <b>Dein Passwort</b>&nbsp;&nbsp;<span onClick={() => openWindow('notification', { content: <><b>Passwort-Richtlinie</b><br /><br />{configuration.passwordPolicies.map(pp => <React.Fragment key={pp}>- {pp}<br /></React.Fragment>)}</> })} style={{ fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}>Passwort-Richtlinie</span><br />
                    <InputField type='password' value={data.password || ''} setValue={value => editData('password', value)} label='Passwort' placeholder='Passwort' />
                    <b>Passwort wiederholen</b>
                    <InputField type='password' value={data.passwordRepeat || ''} setValue={value => editData('passwordRepeat', value)} label='Passwort wiederholen' placeholder='Passwort wiederholen' />

                    {
                      data.job_search &&
                      (
                        <>
                          <hr />
                          <i style={{ color: 'grey', fontSize: 13 }}>Damit wir dich bei deiner Job-Suche unterstützen können, mach' bitte noch folgende Angaben:</i>
                          <br /><br />
                          <b>Dein Status</b>
                          <SelectField
                            options={DomainData.status}
                            value={data.status || []}
                            setValue={v => editData('status', v)}
                            style={{}}
                          />
                          <b>Dein(e) Wunsch-Fachgebiet(e)</b>
                          <SelectField
                            options={DomainData.areasOfExpertise}
                            value={data.subject_area || []}
                            setValue={v => editData('subject_area', v)}
                            style={{}}
                            label='Wunsch-Fachgebiet(e)'
                            multi
                          />
                          {/* <AutoSuggestField value={data.subject_area || ''} setValue={(v) => editData('subject_area', v)} suggestions={DomainData.areasOfExpertise} label='Fachgebiet' placeholder='Dein (Wunsch-)Fachgebiet' /> */}
                          <b>Dein Wohnort</b>
                          <PlacesAutoComplete value={data.city || ''} setValue={(v) => editData('city', v)} label='Wohnort' placeholder='Deinen Wohnort' map={mapInstance.map} mapApi={mapInstance.api} />
                        </>
                      )
                    }

                    <Row>
                      <Col md={12} xs={12} style={{ marginTop: 24 }}>
                        <table>
                          <tr>
                            <td>
                              <CheckField
                                setValue={(value) => editData('dataPrivacy', value)}
                                value={data.dataPrivacy || false}
                              />
                            </td>
                            <td>
                              <p style={{ paddingLeft: 10, color: 'grey', fontSize: 12, marginBottom: 0 }}>
                                Ich bin mit der <a style={{ color: 'black', textDecoration: 'underline' }} href={configuration.website + configuration.websiteRoutes.dataPrivacy} rel='noopener noreferrer' target='_blank'>Datenschutzerklärung</a> & den <a style={{ color: 'black', textDecoration: 'underline' }} href={configuration.website + configuration.websiteRoutes.agb} rel='noopener noreferrer' target='_blank'>AGBs</a> einverstanden
                              </p>
                            </td>
                          </tr>
                        </table>
                      </Col>
                    </Row>
                    <br />
                    <center><PrimaryButton onClick={() => makeSignup(data)} scale={1}>Bestätigen</PrimaryButton></center>
                  </>
                  )
            }
              </>
              )
        }

      </WindowWrapper>
    </>
  );
};

export default Signup;
